<template>
  <div id="customerBranchMoodReportPage">
    <vs-popup
      id="branchMoodReportPopup"
      :active.sync="isActive"
      fullscreen
      title="Mood Kayıtları"
      v-esc="escape"
    >
      <branch-mood-report :selected="selectedGroup" />
    </vs-popup>
    <referral-detail-modal
      :active.sync="isReferralDetailActive"
      :customerId="selectedCustomerId"
      :transaction="selectedTransaction"
    />
    <vs-table
      id="customerBranchMoodReport"
      ref="table"
      :data="moodTransactions"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col v-if="$isCenterBranch()" vs-type="flex" class="w-auto">
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button
                      @click="getExcel"
                      class="panel-action text-dark xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-download"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th style="width: 13%;">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'type' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('type')"
            >İşlem Tipi & Nedeni</vs-button
          >
        </vs-th>
        <vs-th style="width: 17%;">
          <vs-button class="p-1 weight-600" color="primary" type="flat">Müşteri Ad Soyad</vs-button>
        </vs-th>
        <vs-th style="width: 10%;">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'customer.Phone' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('customer.Phone')"
            >Telefon</vs-button
          >
        </vs-th>
        <vs-th style="width: 11%;">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'quantity' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('quantity')"
            >Kazanılan/Harcanan<br/>Mood</vs-button
          >
        </vs-th>
        <vs-th style="width: 17%;">
          <vs-button class="p-1 weight-600" color="primary" type="flat">Referans Ad Soyad</vs-button>
        </vs-th>
        <vs-th style="width: 10%;">
          <vs-button class="p-1 weight-600" color="primary" type="flat">Referans Telefon</vs-button>
        </vs-th>
        <vs-th style="width: 9%;">
          <vs-button class="p-1 weight-600" color="primary" type="flat">Referans Kazanılan<br/>Mood</vs-button>
        </vs-th>
        <vs-th style="width: 5%;">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'branch.Name' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('branch.Name')"
            >Şube</vs-button
          >
        </vs-th>
        <vs-th style="width: 4%;">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'amount' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('amount')"
            >Maliyet</vs-button
          >
        </vs-th>
        <vs-th style="width: 4%;">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('created')"
            >İşlem Tarihi<br/>& Saati</vs-button
          >
        </vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody style="text-align: center">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="text-center">
                <vs-chip :color="tr.isNegative || tr.type == 2 ? 'danger' : (tr.type == 1 ? 'warning' : 'success')" class="weight-600">
                  {{ tr.displayTitle || (tr.type == 0 ? '+ Mood Kazanma' : (tr.product ? tr.product.name : 'Mood İşlemi')) }}
                </vs-chip>
              </p>
            </vs-td>
            <vs-td>
              <p class="text-center weight-600 text-small">{{ tr.customerFullName || tr.customer.name || 'İsim Belirtilmemiş' }}</p>
            </vs-td>
            <vs-td>
              <p class="text-center font-mono weight-600 text-small">{{ tr.customer.phone }}</p>
            </vs-td>
            <vs-td>
              <p class="text-center">
                <vs-chip :color="tr.isNegative || tr.type == 2 ? 'danger' : 'success'" class="weight-700">
                  {{ tr.quantityFormatted || (tr.type == 2 ? '-' + tr.quantity + ' Mood' : '+' + tr.quantity + ' Mood') }}
                </vs-chip>
              </p>
            </vs-td>
            <vs-td>
              <p class="text-center text-small">{{ tr.invitedByName || (tr.invitedByPhone ? 'İsim Belirtilmemiş' : '-') }}</p>
            </vs-td>
            <vs-td>
              <p class="text-center">
                <vs-chip v-if="tr.invitedByPhone" color="warning" class="weight-700 font-mono text-small">{{ tr.invitedByPhone }}</vs-chip>
                <span v-else class="text-grey">-</span>
              </p>
            </vs-td>
            <vs-td>
              <p class="text-center">
                <vs-chip v-if="tr.invitedByPhone || tr.invitedByEarnedMood" color="success" class="weight-700">+{{ tr.invitedByEarnedMood || 2 }} Mood</vs-chip>
                <span v-else class="text-grey">-</span>
              </p>
            </vs-td>
            <vs-td>
              <p class="text-center text-small">{{ tr.branch.name }}</p>
            </vs-td>
            <vs-td>
              <p class="text-center text-warning weight-700 text-small">{{ $toCurrency(tr.amount) }}</p>
            </vs-td>
            <vs-td>
              <p class="text-center text-small">{{ tr.date }} <br/> {{ tr.time }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import PaginationDefault from "../../PaginationDefault";
import GlobalFilter from "../../GlobalFilter";
import {
  GetGroupedBranchMoodTransactions,
  GetGroupedBranchMoodTransactionsExcel,
} from "@/api/Reports";
import BranchMoodReport from "./BranchMoodReport";
import ReferralDetailModal from "./ReferralDetailModal";

export default {
  name: "CustomerMoodReport",
  components: {
    PaginationDefault,
    GlobalFilter,
    BranchMoodReport,
    ReferralDetailModal,
  },
  data() {
    return {
      isActive: false,
      isReferralDetailActive: false,
      selectedCustomerId: null,
      selectedTransaction: null,
      selectedGroup: null,
      moodTransactions: [],
      totalDataRow: 0,
      selected: "",
      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,
      isFilterActive: false,
      filterOptions: [
        "branch",
        "customerEmail",
        "customerPhoneNumber",
        "defaultTimeRange",
        "daysOfWeek",
        "dateRange",
        "timeRange",
        "type",
      ],
      filterOptionNames: [
        "Şube",
        "Müşteri Email",
        "Müşteri Telefon",
        "Zaman Aralığı",
        "Gün",
        "Tarih",
        "Zaman",
        "İşlem Tipi",
      ],
      filterChips: [],
    };
  },
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
  },
  methods: {
    getExcel() {
      let branchId = this.tableOptions.branch
        ? this.tableOptions.branch.id
        : null;
      GetGroupedBranchMoodTransactionsExcel(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Kullanıcı Mood Kayıtları" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    escape() {
      if (this.isActive) this.isActive = false;
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branch: null,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        daysOfWeek: null,
        defaultTimeRange:
          this.$now().getHours() >= 0 && this.$now().getHours() <= 2
            ? {
                name: "Yesterday",
                id: 0,
                dName: "Dün",
              }
            : {
                name: "Today",
                id: 1,
                dName: "Bugün",
              },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        product: null,
        type: null,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      if (col === "branch") this.tableOptions[col] = this.$currentUser.branch;
      else this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getGroupedBranchMoodTransactions() {
      GetGroupedBranchMoodTransactions(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            this.moodTransactions = res.data.items;
            this.totalDataRow = res.data.totalCount;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hata : " + res.status,
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Şube Bakiyeleri Yüklenemedi ! ",
          });
        });
    },
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getGroupedBranchMoodTransactions();
        });
      },
    },
    selected: {
      deep: true,
      handler(val) {
        if (val && val.customer) {
          this.selectedCustomerId = val.customer.id;
          this.selectedTransaction = val;
          this.isReferralDetailActive = true;
          this.selected = "";
        }
      },
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
  created() {
    this.clearFilter();
    if (!this.$isCenterBranch()) {
      let branchPropIndex = this.filterOptions.indexOf("branch");
      this.filterOptions.splice(branchPropIndex, 1);
      this.filterOptionNames.splice(branchPropIndex, 1);
      delete this.tableOptions["branch"];
    }
  },
};
</script>

<style scoped>
#customerBranchMoodReport >>> table {
  width: 100% !important;
  table-layout: auto !important;
}
#customerBranchMoodReport >>> th {
  padding: 6px 4px !important;
  vertical-align: middle !important;
  text-align: center !important;
  line-height: 1.15 !important;
  white-space: nowrap !important;
}
#customerBranchMoodReport >>> td {
  padding: 6px 4px !important;
  vertical-align: middle !important;
  text-align: center !important;
  white-space: nowrap !important;
}
#customerBranchMoodReport >>> td p {
  margin: 0 auto !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  white-space: nowrap !important;
}
#customerBranchMoodReport >>> th .vs-table-text {
  justify-content: center !important;
  text-align: center !important;
  white-space: nowrap !important;
}
#customerBranchMoodReport >>> .vs-chip {
  min-height: 22px !important;
  padding: 2px 8px !important;
  font-size: 0.75rem !important;
  width: auto !important;
  max-width: fit-content !important;
  margin: 0 auto !important;
}
</style>
